function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "030---Locked-File",
  fill: "rgb(0,0,0)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m47 38c-.5522847 0-1 .4477153-1 1v2c0 .5522847.4477153 1 1 1s1-.4477153 1-1v-2c0-.5522847-.4477153-1-1-1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m47 0h-40c-2.76005315.00330612-4.99669388 2.23994685-5 5v18c0 .5522847.44771525 1 1 1s1-.4477153 1-1v-18c0-1.65685425 1.34314575-3 3-3h40c1.6568542 0 3 1.34314575 3 3v39h-7c-2.7600532.0033061-4.9966939 2.2399468-5 5v7h-6c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1h7c.2651948-.0000566.5195073-.1054506.707-.293l12-12c.1875494-.1874927.2929434-.4418052.293-.707v-40c-.0033061-2.76005315-2.2399468-4.99669388-5-5zm-4 46h5.586l-8.586 8.586v-5.586c0-1.6568542 1.3431458-3 3-3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m9 8h2c.5522847 0 1-.44771525 1-1s-.4477153-1-1-1h-2c-.55228475 0-1 .44771525-1 1s.44771525 1 1 1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m45 6h-30c-.5522847 0-1 .44771525-1 1s.4477153 1 1 1h30c.5522847 0 1-.44771525 1-1s-.4477153-1-1-1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m9 14h2c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1h-2c-.55228475 0-1 .4477153-1 1s.44771525 1 1 1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m15 14h23c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1h-23c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m9 20h2c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1h-2c-.55228475 0-1 .4477153-1 1s.44771525 1 1 1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m15 20h6c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1h-6c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m48 21c0-.5522847-.4477153-1-1-1s-1 .4477153-1 1v14c0 .5522847.4477153 1 1 1s1-.4477153 1-1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m2 34v3.184c-1.19435086.4222546-1.99474861 1.5492146-2 2.816v14c.00330738 3.3123376 2.68766243 5.9966926 6 6h16c3.3123376-.0033074 5.9966926-2.6876624 6-6v-14c-.0052514-1.2667854-.8056491-2.3937454-2-2.816v-3.184c0-6.627417-5.372583-12-12-12s-12 5.372583-12 12zm24 20c0 2.209139-1.790861 4-4 4h-16c-2.209139 0-4-1.790861-4-4v-14c0-.5522847.44771525-1 1-1h22c.5522847 0 1 .4477153 1 1zm-6-17h-12v-3c.00000005-3.3137085 2.6862915-5.9999999 6-5.9999999s6 2.6862914 6 5.9999999zm-6-13c5.5203344.0060624 9.9939376 4.4796656 10 10v3h-2v-3c0-4.418278-3.581722-8-8-8s-8 3.581722-8 8v3h-2v-3c.00606237-5.5203344 4.47966557-9.9939376 10-10z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m16.573 42.938c-1.5801299-1.3010688-3.8875142-1.1993497-5.3470238.235719-1.45950961 1.4350686-1.60017709 3.7404064-.3259762 5.342281l-.5 2.991c-.1449642.8701417.1003839 1.7599847.6707961 2.4328823.5704122.6728975 1.4080696 1.0606427 2.2902039 1.0601177h1.278c.8819596.0002309 1.71934-.3876403 2.289527-1.0604994.570187-.6728592.8154084-1.5625314.670473-2.4325006l-.5-2.99c.5847938-.7081843.9035237-1.5985761.901-2.517.0011954-1.1816139-.5214025-2.3029836-1.427-3.062zm-1.527 5.421.58 3.477c.0482121.2899957-.0336209.5865152-.2237455.8107351s-.4692785.3534236-.7632545.3532649h-1.278c-.293976.0001587-.5731299-.129045-.7632545-.3532649s-.2719576-.5207394-.2237455-.8107351l.58-3.477c.0559776-.3325748-.05945-.6709618-.307-.9-.5081138-.4627073-.740434-1.155506-.614-1.831.159333-.808549.791451-1.440667 1.6-1.6.1212824-.020021.2440841-.02939.367-.028.4700708-.0018574.9253754.1640947 1.284.468.4534383.3796862.7155831.9405883.716 1.532.0000066.5564477-.2349589 1.0870265-.647 1.461-.2468999.2286177-.3622683.5660798-.307.898z"
})));

var SvgLocked = function SvgLocked(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 52 60",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLocked, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/locked.ca1eac4d.svg";
export { ForwardRef as ReactComponent };